(function () {
  function getRoot(el) {
    return el && el.closest ? el.closest('.product-select') : null;
  }

  function getState(root) {
    if (!root._productSelectState) {
      root._productSelectState = { index: 0, maxIndex: 0 };
    }
    return root._productSelectState;
  }

  function getGap(track) {
    const styles = window.getComputedStyle(track);
    return parseFloat(styles.columnGap || styles.gap) || 0;
  }

  function getVisibleCount(root) {
    const raw = window.getComputedStyle(root).getPropertyValue('--select-visible');
    const count = parseFloat(raw);
    return count > 0 ? Math.floor(count) : 1;
  }

  function getStep(track) {
    const slide = track.querySelector('.product-select__slide');
    if (!slide) return 0;
    return slide.getBoundingClientRect().width + getGap(track);
  }

  function apply(root) {
    const track = root.querySelector('[data-product-select-track]');
    const nav = root.querySelector('[data-product-select-nav]');
    const prev = root.querySelector('.product-select__arrow[name="previous"]');
    const next = root.querySelector('.product-select__arrow[name="next"]');
    if (!track) return;

    const state = getState(root);
    const step = getStep(track);
    const offset = Math.max(0, Math.min(state.index, state.maxIndex)) * step;
    track.style.transform = 'translate3d(' + -offset + 'px, 0, 0)';

    if (prev) prev.disabled = state.index <= 0;
    if (next) next.disabled = state.index >= state.maxIndex;
    if (nav) {
      if (state.maxIndex <= 0) nav.setAttribute('hidden', '');
      else nav.removeAttribute('hidden');
    }
  }

  function refresh(root) {
    if (!root) return;
    const track = root.querySelector('[data-product-select-track]');
    if (!track) return;

    const state = getState(root);
    const slides = track.querySelectorAll('.product-select__slide');
    const visible = Math.max(1, getVisibleCount(root));
    state.maxIndex = Math.max(0, slides.length - visible);
    if (state.index > state.maxIndex) state.index = state.maxIndex;
    apply(root);
  }

  function init(root) {
    if (!root || root.dataset.selectReady === 'true') return;
    root.dataset.selectReady = 'true';

    const viewport = root.querySelector('[data-product-select-viewport]');
    const track = root.querySelector('[data-product-select-track]');
    if (!viewport || !track) return;

    track.querySelectorAll('img').forEach(function (img) {
      if (img.complete) return;
      img.addEventListener('load', function () {
        refresh(root);
      }, { once: true });
      img.addEventListener('error', function () {
        refresh(root);
      }, { once: true });
    });

    if (typeof ResizeObserver === 'function') {
      let timer;
      new ResizeObserver(function () {
        window.clearTimeout(timer);
        timer = window.setTimeout(function () {
          refresh(root);
        }, 80);
      }).observe(viewport);
    }

    window.requestAnimationFrame(function () {
      refresh(root);
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('.product-select').forEach(init);
  }

  document.addEventListener('click', function (event) {
    const btn = event.target.closest('.product-select__arrow');
    if (!btn) return;

    const root = getRoot(btn);
    if (!root) return;

    event.preventDefault();
    init(root);

    const state = getState(root);
    if (btn.getAttribute('name') === 'previous') {
      state.index = Math.max(0, state.index - 1);
    } else if (btn.getAttribute('name') === 'next') {
      state.index = Math.min(state.maxIndex, state.index + 1);
    }
    apply(root);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    const root = event.target.querySelector('.product-select') || (event.target.classList && event.target.classList.contains('product-select') ? event.target : null);
    if (root) {
      delete root.dataset.selectReady;
      init(root);
    }
  });

  window.ProductSelectionSlider = { init: init, refresh: refresh, initAll: initAll };
})();
